import type { IconSvgObject } from './types';

const Prism01Icon: IconSvgObject = [
  ["path", { d: "M15 7.87044L12.8742 4.04392C12.4932 3.35811 11.5069 3.35811 11.1259 4.04392L2.82537 18.9848C2.45508 19.6513 2.93704 20.4704 3.69953 20.4704H20.3005C21.063 20.4704 21.545 19.6513 21.1747 18.9848L18.3889 13.9704", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: "1.5", key: "0" }],
  ["path", { d: "M22 6.47044L8 9.47044L22 15.4704M21.5 10.9704L9.58117 9.64662", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: "1.5", key: "1" }],
  ["path", { d: "M8 9.47044L2 10.4704", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: "1.5", key: "2" }]
];

export default Prism01Icon;
